// ViewGerenciarConfigSistema/index.tsx
import { Table, Input, Button, Skeleton } from "antd";
import { useConfigSistema } from "./hooks/useConfigSistema";

export default function ViewGerenciarConfigSistema() {
  const { configs, loading, savingId, salvarConfig, contextHolder } =
    useConfigSistema();

  const columns = [
    {
      title: "Chave",
      dataIndex: "chave",
      width: "25%",
    },
    {
      title: "Valor",
      dataIndex: "valor",
      width: "30%",
      render: (text: string, record: any) => (
        <Input
          defaultValue={text}
          onChange={(e) => (record.valor = e.target.value)}
        />
      ),
    },
       {
      title: "Descrição",
      dataIndex: "descricao",
      width: "30%",
      render: (text: string, record: any) => (
        <Input
          defaultValue={text}
          onChange={(e) => {
            record.descricao = e.target.value;
          }}
        />
      ),
    },
   
    {
      title: "Ações",
      width: "15%",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          loading={savingId === record.id}
          onClick={() =>
            salvarConfig(record.id, record.valor, record.descricao)
          }
        >
          Salvar
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      {contextHolder}

      <h1>Configurações do Sistema</h1>

      {loading ? (
        <Skeleton active />
      ) : (
        <Table
          rowKey="id"
          columns={columns}
          dataSource={configs}
          pagination={false}
        />
      )}
    </div>
  );
}
